import React from "react"

export interface IRadioButtonProps {
    name: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string | JSX.Element;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export class RadioButton extends React.PureComponent<IRadioButtonProps>
{
    onChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onChange((e.target as HTMLInputElement).checked)
    }

    render() {
        const { name, checked, disabled, label, style } = this.props;
        return (
            <label className="radioBtn form-label" style={{ ...style }}>
                <input type="radio"
                    name={name}
                    checked={checked}
                    onChange={this.onChange}
                    disabled={disabled} />
                <svg className="svg"
                    fill="currentColor"
                    preserveAspectRatio="xMidYMid meet"
                    height="25px"
                    width="25px"
                    viewBox="0 0 25 25">
                    <circle className="radioOutline" cx="13" cy="13" r="9" />
                    {checked && <circle className="radioDot" cx="13" cy="13" r="6" />}
                </svg>
                {label}
            </label>
        );

    }
}

export default RadioButton;